export default __webpack_public_path__ + "static/media/barsOrange.1c9928f2.svg";